import classNames from 'classnames'
import React from 'react'
import { useModalStateStore } from '../../utils'
import { useLiveViewStateStore } from './LiveViewStore'
import Blackmask from './Blackmask'
import { BrightnessControls, LiveViewStream, Tabs, ZoomFocusControls } from './components'
import { LiveViewErrorBoundary } from './LiveViewErrorBoundary'
import styles from './LiveViewUI.module.css'

export const FULLSCREEN_WIDTH = '65vw'
export const FULLSCREEN_CONTROL_WIDTH = '30vw'

const LiveViewControls: React.FC<{
    fullscreen: boolean
    NORMAL_WIDTH: string
}> = ({ fullscreen, NORMAL_WIDTH }) => {
    const { selectedTab } = useLiveViewStateStore()

    return (
        <div className={styles.controls}>
            {selectedTab === 'focusZoom' && (
                <LiveViewErrorBoundary>
                    <ZoomFocusControls fullscreen={fullscreen} />
                </LiveViewErrorBoundary>
            )}

            {selectedTab === 'brightness' && (
                <LiveViewErrorBoundary>
                    <BrightnessControls fullscreen={fullscreen} />
                </LiveViewErrorBoundary>
            )}

            {selectedTab === 'blackMask' && (
                <LiveViewErrorBoundary>
                    <Blackmask fullscreen={fullscreen} controlWidth={FULLSCREEN_CONTROL_WIDTH} />
                </LiveViewErrorBoundary>
            )}
        </div>
    )
}

export const LiveViewUI: React.FC<{ fullscreen?: boolean }> = ({ fullscreen = false }) => {
    const { selectedTab, isPmView } = useLiveViewStateStore()
    const { isModalOpen, closeModal } = useModalStateStore()
    if (fullscreen === false && isModalOpen('LiveViewFullscreenModal')) {
        return null
    }
    const closeModalOnStopStream = () => {
        closeModal('LiveViewFullscreenModal')
    }
    const NORMAL_WIDTH = isPmView ? '48vw' : '38vw'
    return (
        <div>
            <LiveViewErrorBoundary>
                <Tabs fullscreen={fullscreen} closeModalOnStopStream={closeModalOnStopStream} />
            </LiveViewErrorBoundary>
            <div className={classNames(styles.layout, { [styles.fullscreen]: fullscreen })}>
                <LiveViewErrorBoundary>
                    <LiveViewStream disabled={selectedTab === 'blackMask'} fullscreen={fullscreen} />
                </LiveViewErrorBoundary>
                <LiveViewControls NORMAL_WIDTH={NORMAL_WIDTH} fullscreen={fullscreen} />
            </div>
        </div>
    )
}
